import React from 'react';
import { X } from 'lucide-react';

const TONE_CLASS = {
  success: 'alert-success',
  danger: 'alert-danger',
  warning: 'alert-warning',
  info: 'alert-info',
};

/**
 * System message bar, rendered above the page header and frozen to the top so
 * it stays visible while scrolling (per app-wide UI convention).
 */
export default function McpMessageBar({ message, onClose }) {
  if (!message) return null;
  const toneClass = TONE_CLASS[message.tone] || 'alert-info';
  return (
    <div
      className={`alert ${toneClass} mb-0 rounded-0 d-flex align-items-center justify-content-between sticky-top`}
      role="alert"
      style={{ top: 0, zIndex: 1080 }}
    >
      <span className="me-3">{message.text}</span>
      <button
        type="button"
        className="btn btn-sm btn-link text-reset p-0 d-flex align-items-center"
        aria-label="Dismiss message"
        onClick={onClose}
      >
        <X size={16} />
      </button>
    </div>
  );
}
